import { Route, Routes } from 'react-router-dom';
import {
  ItemFormPage,
  ItemsPage,
  LocationsPage,
  MovementsListPage,
  SubcategoriesPage,
} from '@/modules/inventory/pages';
import { inventoryPaths } from '@/modules/inventory/paths';
import { RequirePermission } from '@/shared/components/RequirePermission';

export function InventoryModule() {
  return (
    <Routes>
      <Route index element={<ItemsPage />} />
      <Route
        path={inventoryPaths.itemNew}
        element={
          <RequirePermission permission="inventory.write">
            <ItemFormPage />
          </RequirePermission>
        }
      />
      <Route path={inventoryPaths.itemEdit} element={<ItemFormPage />} />
      <Route
        path={inventoryPaths.movements}
        element={
          <RequirePermission permission="inventory.movements.read">
            <MovementsListPage />
          </RequirePermission>
        }
      />
      <Route
        path={inventoryPaths.locations}
        element={
          <RequirePermission permission="inventory.movements.read">
            <LocationsPage />
          </RequirePermission>
        }
      />
      <Route path={inventoryPaths.subcategories} element={<SubcategoriesPage />} />
    </Routes>
  );
}
